import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {TextInput, DatePicker} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import validator from 'validator';
import {PERMISSIONS} from '../../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../../_helpers/UserPermissionSingleton';

export default class CourseInformation extends React.Component {
    static get props(){
        return{
            courseName: PropTypes.string,
            courseNumber: PropTypes.string,
            estimatedEnrollment: PropTypes.string,
            courseStartDate: PropTypes.string,
            courseEndDate: PropTypes.string,
            comments: PropTypes.string,
            updateInputs: PropTypes.func,
            courseId: PropTypes.string
        };
    }

    constructor (props) {
        super(props);

        this.state = {
            courseNameInputState: 'default',
            courseNameErrorMsg: null,
            courseCodeInputState: 'default',
            courseCodeErrorMsg: null,
            estimatedEnrollmentInputState: 'default',
            estimatedEnrollmentErrorMsg: null,
            courseStartDateInputState: 'default',
            courseStartDateErrorMsg: null,
            courseEndDateInputState: 'default',
            courseEndDateErrorMsg: null

        };

        this.handleClassStartDateChange = this.handleClassStartDateChange.bind(this);
        this.handleCourseEndDateChange = this.handleCourseEndDateChange.bind(this);
        this.handleCourseNameChange = this.handleCourseNameChange.bind(this);
        this.handleCourseNoChange = this.handleCourseNoChange.bind(this);
        this.handleEstimatedEnrollmentsChange = this.handleEstimatedEnrollmentsChange.bind(this);
    }

    getFormatedDates = (date) => {
        const d = new Date(date);
        const ISODATE = d.toISOString();
        const dateMoment =  moment(ISODATE).format();
        return({dateISO: ISODATE, dateMoment: dateMoment});

    }

    handleClassStartDateChange(date) {
        const NewStartDate = this.getFormatedDates(date).dateMoment;
        if(this.validateCourseStartDate(NewStartDate)){
            this.props.options.updateInputs("courseStart", NewStartDate);
            this.props.options.enableSubmit(true);
        }
        else{
            this.props.options.enableSubmit(false);
        }
    }

    handleCourseEndDateChange(date) {
        const NewEndDate = this.getFormatedDates(date).dateMoment;
        if(this.validateCourseEndDate(NewEndDate)){
            this.props.options.updateInputs("courseEnd", NewEndDate);
            this.props.options.enableSubmit(true);
        }
        else{
            this.props.options.enableSubmit(false);
        }
    }

    handleCourseNameChange(e){
        const MAX_COURSE_LENGTH = 40;
        const inputLength = e.target.value.length;
        if(inputLength <= MAX_COURSE_LENGTH) {
            this.props.options.enableSubmit(this.validateCourseName(e.target.value));
            this.props.options.updateInputs("courseName",e.target.value);
        }
    }

    handleCourseNoChange(e){
        this.props.options.enableSubmit(this.validateCourseCode(e.target.value));
        this.props.options.updateInputs("courseNumber",e.target.value);
    }

    handleEstimatedEnrollmentsChange(e){
        this.props.options.enableSubmit(this.validateEstimatedEnrollment(e.target.value));
        this.props.options.updateInputs("estimatedEnrollments",e.target.value);
    }

    validateCourseName(value) {
        const isCourseNameEmpty = validator.isEmpty(value);
        this.setState({
            courseNameInputState: isCourseNameEmpty ? 'error' : 'default',
            courseNameErrorMsg: isCourseNameEmpty ? 'Course name is required' : null
        });

        return !isCourseNameEmpty;
    }

    validateCourseCode(value) {
        const isCourseCodeEmpty = validator.isEmpty(value);
        this.setState({
            courseCodeInputState: isCourseCodeEmpty ? 'error' : 'default',
            courseCodeErrorMsg: isCourseCodeEmpty ? 'Course code is required' : null
        });

        return !isCourseCodeEmpty;
    }

    validateEstimatedEnrollment(value) {
        const isEmpty = validator.isEmpty(value);
        const isNumber = validator.isNumeric(value);
        const isEnrollment = validator.isInt(value,{min:10});
        this.setState({
            estimatedEnrollmentInputState: !isNumber  ? 'error' : !isEnrollment  ? 'error' : 'default',
            estimatedEnrollmentErrorMsg: isEmpty ? 'Est enrollment is required' : !isNumber ? 'Est enrollment is invalid': !isEnrollment ? 'Minimum enrollment must be 10': 'null',
        });

        return !isEmpty && isNumber && isEnrollment;
    }

    validateCourseStartDate(value) {
        const isValid = validator.toDate(value);
        const courseStart = value;
        const courseEndDate = this.props.options.courseEndDate;
        if (courseStart > courseEndDate){
            return alert('Course start date should be lesser than course end date');
        }
        this.setState({
            courseStartDateInputState: !isValid ? 'error' : 'default',
            courseStartDateErrorMsg: !isValid ? 'Invalid date' : null,
        });

        return isValid;
    }

    validateCourseEndDate(value) {
        const isValid = validator.toDate(value);
        this.setState({
            courseEndDateInputState: !isValid ? 'error' : 'default',
            courseEndDateErrorMsg: !isValid ? 'Invalid date' : null,
        });

        return isValid;
    }

    render(){
        const refreshKeyCourseEnd = this.props.options.courseEndDate;
        const {courseStartDate,courseEndDate} = this.props.options;
        return (
            <div className="course-info">
                <div className="row course-info">
                    <TextInput id="courseName"
                        labelText="Course Name"
                        fancy={false}
                        changeHandler={this.handleCourseNameChange}
                        inputState= {!validator.isEmpty(this.props.options.courseId) || UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_course_name) ? 'disabled' : this.state.courseNameInputState}
                        errorMessage={this.state.courseNameErrorMsg}
                        value={this.props.options.courseName}
                    />
                </div>
                <div className="row course-info">
                    <TextInput id="courseNumber"
                        labelText="Course Number"
                        fancy={false}
                        changeHandler={this.handleCourseNoChange}
                        inputState= {!validator.isEmpty(this.props.options.courseId) || UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_course_number) ? 'disabled' :this.state.courseCodeInputState}
                        errorMessage={this.state.courseCodeErrorMsg}
                        value={this.props.options.courseNumber}
                    />
                </div>
                <div className="row course-info">
                    <TextInput id="estimatedEnrollments"
                        labelText="Estimated Enrollment"
                        min={10}
                        fancy={false}
                        changeHandler={this.handleEstimatedEnrollmentsChange}
                        inputState= {!validator.isEmpty(this.props.options.courseId) || UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_estimated_enrollment) ? 'disabled' :this.state.estimatedEnrollmentInputState}
                        errorMessage={this.state.estimatedEnrollmentErrorMsg}
                        value={this.props.options.estimatedEnrollment}
                    />
                </div>
                <div className="row course-info" >
                    {
                        courseStartDate && <DatePicker
                            id="classStartDate"
                            dateFormat='yyyy-mm-dd'
                            labelText="Class Start Date (yyyy-mm-dd)"
                            datePickerValue={moment(courseStartDate).format('YYYY-MM-DD')}
                            changeHandler={this.handleClassStartDateChange}
                            disablePast={true}
                            inputState= {!validator.isEmpty(this.props.options.courseId)|| UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_class_startdate) ? 'disabled' :this.state.courseStartDateInputState}
                            errorMessage={this.state.courseStartDateErrorMsg}
                        />
                    }
                    {
                        !courseStartDate && <DatePicker
                            id="classStartDate"
                            dateFormat='YYYY-MM-DD'
                            inputState="default"
                            labelText="Class Start Date (yyyy-mm-dd)"
                            disablePast={true}
                        />
                    }
                </div>
                <div className="row course-info" >
                    {
                        courseEndDate && <DatePicker
                            id="classStartDate"
                            dateFormat='YYYY-MM-DD'
                            labelText="Class End Date (yyyy-mm-dd)"
                            datePickerValue={moment(courseEndDate).format('YYYY-MM-DD')}
                            changeHandler={this.handleCourseEndDateChange}
                            disablePast={true}
                            inputState= {!validator.isEmpty(this.props.options.courseId)|| UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_class_enddate) ? 'disabled' :this.state.courseEndDateInputState}
                            errorMessage={this.state.courseEndDateErrorMsg}
                        />
                    }
                    {
                        !courseEndDate && <DatePicker
                            id="classStartDate"
                            dateFormat='yyyy-mm-dd'
                            inputState="default"
                            labelText="Class End Date (yyyy-mm-dd)"
                            disablePast={true}

                        />
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/CourseInformation.js